import React, { useRef, useState } from "react";
import { useNavigate } from "react-router";
import { blogPosts } from "../controller/global";

const ExploreOtherCaseStudy = ({ currentSlug }) => {
  const navigate = useNavigate();
  const [carouselIndex, setCarouselIndex] = useState(0);
  const carouselRef = useRef(null);
  const filtered = blogPosts.filter((post) => post.slug !== currentSlug);
  const total = filtered.length;

  const scrollToIndex = (idx) => {
    if (carouselRef.current) {
      const cardWidth = carouselRef.current.firstChild?.offsetWidth || 300;
      carouselRef.current.scrollTo({ left: idx * (cardWidth + 14), behavior: "smooth" });
    }
  };

  const handlePrev = () => {
    if (carouselIndex === 0) return;
    setCarouselIndex((prev) => {
      const newIndex = prev - 1;
      scrollToIndex(newIndex);
      return newIndex;
    });
  };

  const handleNext = () => {
    if (carouselIndex === total - 1) return;
    setCarouselIndex((prev) => {
      const newIndex = prev + 1;
      scrollToIndex(newIndex);
      return newIndex;
    });
  };

  return (
    <section className="ea-wrap ea-section">
      <div className="ea-section-head">
        <div>
          <div className="ea-eyebrow">Keep exploring</div>
          <h2>Other case<br />studies.</h2>
        </div>
        <div className="aa-scroll-nav" style={{ marginTop: 0 }}>
          <button
            aria-label="Previous case study"
            onClick={handlePrev}
            disabled={carouselIndex === 0}
            className="aa-scroll-btn"
            style={carouselIndex === 0 ? { opacity: 0.35, cursor: "not-allowed" } : undefined}
          >
            ←
          </button>
          <button
            aria-label="Next case study"
            onClick={handleNext}
            disabled={carouselIndex === total - 1}
            className="aa-scroll-btn"
            style={carouselIndex === total - 1 ? { opacity: 0.35, cursor: "not-allowed" } : undefined}
          >
            →
          </button>
        </div>
      </div>

      <div className="aa-scroller" ref={carouselRef}>
        {filtered.map((post) => (
          <a
            key={post.slug}
            className="cd-explore-card"
            href={`/case-studies/${post.slug}`}
            onClick={(e) => { e.preventDefault(); navigate(`/case-studies/${post.slug}`); }}
          >
            <img className="cd-explore-img" src={post.image} alt={post.title} loading="lazy" />
            <div className="cd-explore-body">
              <div className="ea-tags"><span>{post.category}</span></div>
              <h3>{post.title}</h3>
              <p>{post.description.slice(0, 90)}...</p>
              <span className="cd-explore-link">Read the case study →</span>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
};

export default ExploreOtherCaseStudy;
